import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { ImagesDocumentsContent } from './components/ImagesDocumentsContent';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface NCFileDetailsNCFileDocumentsProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const NCFileDetailsNCFileDocumentsComponent: FC<NCFileDetailsNCFileDocumentsProps> = ({
  getNCFileById,
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  ncFileData,
  operationsSearch,
  getNCFileByName,
}) => {
  const title = useTitle();

  useNCFileDetails({
    clearTools,
    getNCFileById,
    getTools,
    getProductionBatchByNCFile,
    updateHeaderConfig,
    operationsSearch,
    getNCFileByName,
  });

  const ncFileId = ncFileData?.data?.ncFileId;

  return (
    <DetailsPageWrapper title={title.ncFile}>
      {ncFileId != null && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={ncFileId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.NcFile} />
        </View>
      )}
    </DetailsPageWrapper>
  );
};

const NCFileDetailsNCFileDocuments = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  getNCFileById,
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsNCFileDocumentsComponent);

export { NCFileDetailsNCFileDocuments };
